import React from 'react';
import { PropTypes } from 'prop-types';

const WorkflowStageFilter = ({ column: { filterValue, setFilter, preFilteredRows, id, filterType, options }, showStpOnly }) => {
  const [inputValue, setInputValue] = React.useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  const [stpOnly, setStpOnly] = React.useState(filterValue?.options?.stpOnly === true && showStpOnly === true);
  const node = React.useRef();

  const handleClickOutside = (e) => {
    if (node === null || node.current === null) {
      return;
    }
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    setShowFilter(false);
  };

  const baseOptions = React.useMemo(() => {
    const opts = new Set();
    opts.add({ title: 'Pending Initial Review', value: 'pendingreview' });
    opts.add({ title: 'Under Initial Review', value: 'underinitialreview' });
    opts.add({ title: 'Pending Secondary Review', value: 'pendingsecondaryreview' });
    opts.add({ title: 'Under Secondary Review', value: 'undersecondaryreview' });
    opts.add({ title: 'Pending Expert Review', value: 'pendingexpertreview' });
    opts.add({ title: 'Under Expert Review', value: 'underexpertreview' });
    opts.add({ title: 'Complete', value: 'complete' });
    opts.add({ title: 'Automatically Closed', value: 'closed' });

    return [...opts.values()];
  }, [id]);

  if (!options || options.length === 0) {
    options = baseOptions;
  }

  if (!filterType) {
    filterType = 'workflow';
  }

  const filterInput = React.createRef();

  const clear = () => {
    for (let i = 0, l = filterInput.current.options.length; i < l; i += 1) {
      filterInput.current.options[i].selected = false;
    }
    setShowFilter(false);
    setInputValue([]);
    setStpOnly(false);
    setFilter({
      filter: [],
      options: null,
      filterType: `${ filterType }`
    });
  };

  const apply = () => {
    setShowFilter(false);
    setFilter({
      filter: inputValue,

      options: stpOnly ? { stpOnly } : null,
      filterType: `${ filterType }`
    });
  };

  React.useEffect(() => {
    setInputValue(filterValue != null && filterValue.filter.length > 0 ? filterValue.filter : '');
    setStpOnly(filterValue?.options?.stpOnly === true);

    if (filterValue?.filter && filterValue.filter.length > 0) {
      for (let i = 0, l = filterValue.filter.length; i < l; i += 1) {
        for (let j = 0, k = filterInput.current.options.length; j < k; j += 1) {
          if (filterInput.current.options[j].value === filterValue.filter[i]) {
            filterInput.current.options[j].selected = true;
          }
        }
      }
    } else {
      for (let i = 0, l = filterInput.current.options.length; i < l; i += 1) {
        filterInput.current.options[i].selected = false;
      }
    }
  }, [filterValue]);

  React.useEffect(() => {
    if (showFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilter]);

  const keyHit = (e) => {
    if (e.keyCode === 13) {
      apply();
    }
  };

  const onStpClick = e => setStpOnly(e.target.checked);

  return (
    <div ref={ node } className={ `clickover clickover-bottom filter ${ showFilter ? 'active' : '' }` }>
      <button type="button" onClick={ () => setShowFilter(!showFilter) } className={ `btn btn-link filter-menu ${ filterValue != null && filterValue.filter.length > 0 ? 'filter-active' : '' }` }>☰</button>
      <div className="clickover-container">
        <div className="card card-primary">
          <div className="card-body">
            <div className="columns workflow-filter">
              <div className="col-12">
                <select
                  ref={ filterInput }
                  multiple
                  onChange={ (e) => {
                    const ops = e.target.options;
                    const value = [];
                    for (let i = 0, l = ops.length; i < l; i += 1) {
                      if (ops[i].selected) {
                        value.push(ops[i].value);
                      }
                    }
                    setInputValue(value);
                  } }
                  onKeyUp={ (e) => { keyHit(e); } }
                >
                  { options.map((option, i) => (
                    <option key={ (option && option.value) || option } value={ (option && option.value) || option }>
                      { (option && option.title) || option }
                    </option>
                  ))}
                </select>
              </div>
              <div className={ `col-12 ${ inputValue.length > 0 && inputValue.includes('complete') ? '' : 'hide' }` }>
                <input
                  id="include-stp"
                  type="checkbox"
                  value="Yes"
                  checked={ stpOnly }
                  onChange={ e => onStpClick(e) }
                />
                <label className="wf_label">STP Only</label>
              </div>
              <div className="col-6 middle">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={ () => apply() }
                ><span className="icon icon-search" /> Filter</button>
              </div>
              <div className="col-6 middle">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={ inputValue.length === 0 }
                  onClick={ () => {
                    clear();
                  } }
                ><span className="icon icon-cross" /> Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkflowStageFilter.propTypes = {
  column: PropTypes.shape().isRequired,
  showStpOnly: PropTypes.bool
};

WorkflowStageFilter.defaultProps = {
  showStpOnly: false
};

export default WorkflowStageFilter;
